(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["influencer-product-request"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sz-influencer-request]').forEach(function (requestSection) {
      var link = requestSection.querySelector('[data-sz-request-link]');
      if (!link || link.dataset.szReady === 'true') return;
      link.dataset.szReady = 'true';

      link.addEventListener('click', function () {
        var productArea = requestSection.previousElementSibling;
        var variantInput = productArea ? productArea.querySelector('form[action*="/cart/add"] [name="id"]') : null;
        // The CTA is placed as its own section in templates/product.json, so the
        // buy box is not a DOM sibling. Fall back to the main product section.
        if (!variantInput) {
          variantInput = document.querySelector('.product-single form[action*="/cart/add"] [name="id"]');
        }
        var variantId = variantInput ? variantInput.value : requestSection.dataset.initialVariantId;
        var variantTitle = '';

        if (variantInput && variantInput.tagName === 'SELECT' && variantInput.selectedIndex >= 0) {
          variantTitle = variantInput.options[variantInput.selectedIndex].text;
        } else if (variantId === requestSection.dataset.initialVariantId) {
          variantTitle = requestSection.dataset.initialVariantTitle;
        }

        var params = new URLSearchParams();
        params.set('product_name', requestSection.dataset.productName || '');
        params.set('product_url', requestSection.dataset.productUrl || window.location.href.split('?')[0]);
        params.set('product_id', requestSection.dataset.productId || '');
        params.set('product_sku', requestSection.dataset.initialVariantSku || '');
        if (variantId) params.set('variant_id', variantId);
        if (variantTitle) params.set('variant_title', variantTitle.trim());
        link.href = '/pages/under-the-influence-product-request?' + params.toString();
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-protection-decline"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-shipping-protection-decline]';
    let protectedCheckoutPending = false;

    const update = (container) => {
      const checkbox = container.querySelector('[data-shipping-protection-decline-checkbox]');
      if (!checkbox) return;

      const accepted = checkbox.checked;
      const protectedCheckout = container.getAttribute('data-shipping-protection-in-cart') === 'true';
      const checkoutAllowed = accepted || protectedCheckout;
      const form = container.closest('form');

      container.querySelectorAll('[data-shipping-protection-audit-field]').forEach((field) => {
        field.disabled = !accepted;
        if (!field.hasAttribute('data-shipping-protection-timestamp')) {
          field.value = accepted ? field.getAttribute('data-audit-value') : '';
        }
      });

      const timestamp = container.querySelector('[data-shipping-protection-timestamp]');
      if (timestamp) timestamp.value = accepted ? new Date().toISOString() : '';

      if (form) {
        form.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
          button.disabled = !checkoutAllowed;
          button.setAttribute('aria-disabled', checkoutAllowed ? 'false' : 'true');
        });
        form.querySelectorAll('[data-cart-checkout-buttons]').forEach((checkoutButtons) => {
          checkoutButtons.classList.toggle('cart__buttons--disabled', !checkoutAllowed);
        });
      }
    };

    const initialize = (root = document) => {
      root.querySelectorAll(selector).forEach(update);
    };

    const syncProtectionState = async () => {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin' });
        const cart = await response.json();
        const protectedCheckout = cart.items.some((item) => item.handle === 'insureshield-shipping-insurance-product');
        document.querySelectorAll(selector).forEach((container) => {
          container.setAttribute('data-shipping-protection-in-cart', protectedCheckout ? 'true' : 'false');
          update(container);
        });
        if (protectedCheckout) protectedCheckoutPending = false;
      } catch (error) {
        protectedCheckoutPending = false;
      }
    };

    document.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-shipping-protection-decline-checkbox]');
      if (!checkbox) return;
      const container = checkbox.closest(selector);
      if (container) {
        update(container);
        requestAnimationFrame(() => update(container));
      }
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.checkout-cart-widget')) return;
      protectedCheckoutPending = true;
      window.setTimeout(syncProtectionState, 750);
      window.setTimeout(syncProtectionState, 2000);
    }, true);

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      const form = submitter.closest('form');
      const checkbox = form && form.querySelector('[data-shipping-protection-decline-checkbox]');
      const container = checkbox && checkbox.closest(selector);
      const protectedCheckout = container && container.getAttribute('data-shipping-protection-in-cart') === 'true';
      const checkoutAllowed = protectedCheckoutPending || protectedCheckout;
      protectedCheckoutPending = false;
      if (checkbox && !checkbox.checked && !checkoutAllowed) {
        event.preventDefault();
        checkbox.focus();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(selector)) update(node);
          initialize(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
